import React from "react";
import './ManageTravelers.scss';
import Modal from "react-bootstrap/Modal";
import { DateOfBirthField, SelectDropDownField, TextInputField } from "../../../components/form-fields";
import { LoadingSpinnerDotted } from "../../../components/loading-spinner/Loader";
import { ImageUpload } from "../../../components/image-upload";
import { imageUrlTravellers } from "../../../services/CommonUrl";
import moment from "moment";

const TravelerModal = ({
  show,
  onClose,
  formik,
  mode = "add",
  isLoading,
  blankImg,
  travelerData
}) => {
  const isEditMode = mode === "edit";
  const isViewMode = mode === "view";
  return (
    <Modal
      show={show}
      onHide={onClose}
      keyboard={false}
      size="lg"
      className="add-travellers-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === "edit"
            ? "Edit Traveler"
            : mode === "view"
              ? "View Traveler"
              : "Add Traveler"}
        </Modal.Title>
      </Modal.Header>
      {isViewMode ? (
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-4">
              <p>Name :</p>
            </div>
            <div className="col-md-8">
              <p className="text-black">{travelerData?.title} {travelerData?.first_name} {travelerData?.last_name}</p>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <p>Gender :</p>
            </div>
            <div className="col-md-8">
              <p className="text-black">{travelerData?.gender}</p>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <p>Date of Birth :</p>
            </div>
            <div className="col-md-8">
              <p className="text-black">{moment(travelerData?.dob).format("DD-MM-YYYY")}</p>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <p>Passport No :</p>
            </div>
            <div className="col-md-8">
              <p className="text-black">{travelerData?.passport_no ? travelerData?.passport_no : "N/A"}</p>
              <div className="row">
                <div className="col-4 mt-2"><img className="rounded" src={travelerData.passport_front_image ? imageUrlTravellers + travelerData.passport_front_image : blankImg} alt="Image" /></div>
                <div className="col-4 mt-2"><img className="rounded" src={travelerData.passport_back_image ? imageUrlTravellers + travelerData.passport_back_image : blankImg} alt="Image" /></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <p>Social Id No :</p>
            </div>
            <div className="col-md-8">
              <p className="text-black">{travelerData?.socialId_no ? travelerData?.socialId_no : "N/A"}</p>
              <div className="row">
                <div className="col-4 mt-2"><img className="rounded" src={travelerData.socialId_front_image ? imageUrlTravellers + travelerData.socialId_front_image : blankImg} alt="Image" /></div>
                <div className="col-4 mt-2"><img className="rounded" src={travelerData.socialId_back_image ? imageUrlTravellers + travelerData.socialId_back_image : blankImg} alt="Image" /></div>
              </div>
            </div>
          </div>
        </Modal.Body>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="row">
              <div className="mb-3 col-lg-2">
                <SelectDropDownField
                  formik={formik}
                  fieldName="title"
                  labelName="Title"
                  options={["Mr", "Mrs", "Ms"]}
                />
              </div>
              <div className="mb-3 col-lg-5">
                <TextInputField
                  formik={formik}
                  fieldName="first_name"
                  labelName="First Name"
                  placeHolder="First Name"
                />
              </div>
              <div className="mb-3 col-lg-5">
                <TextInputField
                  formik={formik}
                  fieldName="last_name"
                  labelName="Last Name"
                  placeHolder="Last Name"
                />
              </div>

              <div className="mb-3 col-lg-6">
                <SelectDropDownField
                  formik={formik}
                  fieldName="gender"
                  labelName="Gender"
                  options={["Male", "Female", "Prefer not to say"]}
                />
              </div>

              <div className="mb-3 col-lg-6">
                <DateOfBirthField
                  formik={formik}
                  fieldName="dob"
                  labelName="Date of Birth"
                />
              </div>

              <div className="mb-3 col-lg-6">
                <TextInputField
                  formik={formik}
                  fieldName="passport_no"
                  labelName="Passport No."
                  placeHolder="Passport No."
                />
                <div className="row">
                  <div className="mt-3 col-sm-6">
                    <ImageUpload
                      label="Passport front image"
                      name="passport_front_image"
                      accept="image/x-png,image/gif,image/jpeg"
                      formik={formik}
                      initialImage={travelerData?.passport_front_image ? imageUrlTravellers + travelerData?.passport_front_image : ""}
                      blankImg={blankImg}
                    />
                  </div>
                  <div className="mt-3 col-sm-6">
                    <ImageUpload
                      label="Passport back image"
                      name="passport_back_image"
                      accept="image/x-png,image/gif,image/jpeg"
                      formik={formik}
                      initialImage={travelerData?.passport_back_image ? imageUrlTravellers + travelerData?.passport_back_image : ""}
                      blankImg={blankImg}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3 col-lg-6">
                <TextInputField
                  formik={formik}
                  fieldName="socialId_no"
                  labelName="Social Id"
                  placeHolder="Social Id No."
                />
                <div className="row">
                  <div className="mt-3 col-sm-6">
                    <ImageUpload
                      label="Social id front image"
                      name="socialId_front_image"
                      accept="image/x-png,image/gif,image/jpeg"
                      formik={formik}
                      initialImage={travelerData?.socialId_front_image ? imageUrlTravellers + travelerData?.socialId_front_image : ""}
                      blankImg={blankImg}
                    />
                  </div>
                  <div className="mt-3 col-sm-6">
                    <ImageUpload
                      label="Social id back image"
                      name="socialId_back_image"
                      accept="image/x-png,image/gif,image/jpeg"
                      formik={formik}
                      initialImage={travelerData?.socialId_back_image ? imageUrlTravellers + travelerData?.socialId_back_image : ""}
                      blankImg={blankImg}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary-color btn-border-color"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary-color btn-border-color"
            >
              {isLoading ? <LoadingSpinnerDotted /> : isEditMode ? "Update" : "Submit"}
            </button>
          </Modal.Footer>
        </form>
      )}
    </Modal>
  );
};

export default TravelerModal;
